<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

.br_toolbar_div {
    padding-left: 16px;
}

</style>

<template>
<div>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="in"
        class="elevation-1">

        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title><h2 class="br">NAT44 1:1 sessions</h2></v-toolbar-title>
            </v-toolbar>
                
            <div class="br_toolbar_div">
                <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                    <v-text-field
                        v-model="map_id"
                        label="Map id">
                    </v-text-field>
                    <span class="required_err">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        
            <div class="br_toolbar_div">
                <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                    <v-text-field
                        v-model="int_ip_addr"
                        label="Internal IP address">
                    </v-text-field>
                    <span class="required_err">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>

            <div class="br_toolbar_div">
                <v-btn @click="show_sessions"
                        color="primary" class="mb-2"
                        :disabled="invalid">
                        Show sessions
                </v-btn>
            </div>

            <v-toolbar flat>
                <v-text-field v-model="search"
                    append-icon="mdi-magnify" label="Search" single-line hide-details
                ></v-text-field>
            </v-toolbar>
        </template>

        <template v-slot:no-data>
            no records
        </template>
    </v-data-table>
    </ValidationObserver>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js";

export default {
name: "nat11_sessions",
components: { 
    Treeselect, ValidationProvider, ValidationObserver,
},
data: () => ({
    map_id: '',
    int_ip_addr: '',
    search: '',

    headers: [
        { text: 'Internal', value: 'int_addr', align: 'start' },
        { text: 'Translated', value: 'taddr' },
        { text: 'External', value: 'ext_addr' },
        { text: 'Proto', value: 'proto' },
        { text: 'State', value: 'state' },
        { text: 'Expire in', value: 'expire_in' },
    ],

    items: [],
}),

watch: {
},

created() {
},

methods: {
    show_sessions() {
        return new Promise((resolve, reject) => {
            let data = {
                map_id: this.map_id,
                in_addr: this.int_ip_addr,
            };
            api_client.run_post_query('/nat/snat1to1/sessions', data)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.items = response.data.sess;
                }
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },
}

};
</script>
